<template>
  <dialog ref="cookie-dialog" class="cookie-dialog">
    <div class="cookie-dialog-box">
      <div class="cookie-dialog-box-main">
        <p class="heading-5-list-bold">We use cookies</p>

        <p class="medium-text">
          We use essential and optional analytics cookies to improve your experience. By clicking "Accept", you agree to
          our
          <nuxt-link to="/cookie-policy" class="medium-text-bold underline-text link-outline-text"
            >Cookie Policy</nuxt-link
          >
          and
          <nuxt-link to="/privacy-policy" class="medium-text-bold underline-text link-outline-text"
            >Privacy Policy</nuxt-link
          >.
        </p>
      </div>

      <div class="cookie-dialog-box-buttons">
        <button class="text-button medium-text underline-text" @click="setConsent(false)">Decline</button>
        <button class="button black-button-with-white-outline" @click="setConsent(true)" ref="acceptButton">
          Accept
        </button>
      </div>
    </div>
  </dialog>
</template>

<script lang="ts" setup>
const dialog = useTemplateRef('cookie-dialog');
const acceptButton = ref<HTMLButtonElement | null>(null);

const cookieModal = reactive({
  open: () => dialog.value?.show(),
  close: () => dialog.value?.close(),
});

onMounted(() => {
  if (document.cookie.indexOf('vortecCookies=true') === -1) {
    cookieModal.open();
    nextTick(() => {
      acceptButton.value?.focus();
    });
  } else if (document.cookie.indexOf('vortecCookies=true') >= 0) {
    loadScripts();
  }
});

function setConsent(accepted: boolean) {
  const expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 6);

  document.cookie = `vortecCookies=${accepted}; expires=${expiryDate.toUTCString()}; path=/; Secure; SameSite=Strict`;

  if (accepted) loadScripts();

  cookieModal.close();
}

function loadScripts() {
  // Google Tag Manager
  const gtagScript = document.createElement('script');
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-BKELDKN4TK';
  gtagScript.async = true;
  document.head.appendChild(gtagScript);

  const gtagInline = document.createElement('script');
  gtagInline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-BKELDKN4TK');
  `;
  document.head.appendChild(gtagInline);

  // ContentSquare
  const csScript = document.createElement('script');
  csScript.src = 'https://t.contentsquare.net/uxa/6a1f4a82e76a3.js';
  csScript.async = true;
  document.head.appendChild(csScript);
}
</script>
